import { Link } from "react-router-dom";
import OutputStructure from "../../dtos/structure";
import "./styles.css";
import React from "react";
import { IMAGE_HOST } from "../../server/config";
import { externalRedirectUrl } from "../../pages/page-redirect";

type propsType = {
  structure: OutputStructure;
  treeRoot?: String;
  inverse?: boolean;
  className?: string;
  imageBackgroundColor?: string;
  textBackgroundColor?: string;
  textColor?: string;
  TextWrapper?: keyof JSX.IntrinsicElements;
};

function CardStructure({
  structure,
  treeRoot,
  inverse = false,
  className = "",
  imageBackgroundColor,
  textBackgroundColor,
  textColor,
  TextWrapper = "h3",
  ...others
}: propsType) {
  return (
    <Link
      to={
        treeRoot !== undefined
          ? treeRoot + structure.id
          : structure.url
          ? externalRedirectUrl(structure.url)
          : `/${structure.id}`
      }
      style={{
        backgroundColor: imageBackgroundColor
          ? imageBackgroundColor
          : inverse
          ? "white"
          : "#" + structure.color.toString(16).padStart(6, "0"),
      }}
      className={"card-structure" + (className === "" ? "" : " " + className)}
      {...others}
    >
      <div className="logo-container">
        <div className="logo">
          <img
            src={
              IMAGE_HOST +
              ((inverse
                ? structure.logoSimpleColor
                : structure.logoSimpleWhite) ?? undefined)
            }
            alt={structure.id}
          />
        </div>
      </div>
      <div
        className="text-container"
        style={{
          backgroundColor: textBackgroundColor
            ? textBackgroundColor
            : inverse
            ? "#" + structure.color.toString(16).padStart(6, "0")
            : "white",
          color: textColor
            ? textColor
            : inverse
            ? "white"
            : "#" + structure.color.toString(16).padStart(6, "0"),
        }}
      >
        <div className="text">
          {structure.logoTextIsImage ? (
            <img src={IMAGE_HOST + structure.logoText} alt={structure.name} />
          ) : (
            <TextWrapper>{structure.logoText}</TextWrapper>
          )}
        </div>
      </div>
    </Link>
  );
}

export default CardStructure;
